// extracted by mini-css-extract-plugin
module.exports = {"disc":"_2RZR-"};